import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";
import {rentMortgagePaymentStep} from "@/form/helpers/field-choices.js";
import {storageGetJson} from "@/utils/safe-storage.js";

let steps = [
    // =========================================================================
    // Steps originally from: form/steps/initial.js
    // Fields: requested_amount, product_purpose, cc_debt_amount (if debt consolidation),
    //         unsecured_debt_amount (if debt consolidation), in_credit_situation,
    //         income_type, direct_deposit, monthly_income, address,
    //         address_length_months (ON/BC/QC only), own_home (ON/BC/QC only),
    //         requested_amount (PQ brand only), living_situation (ON/BC/QC only),
    //         contact (first_name, last_name, email, phone_number),
    //         sms_verification, dob, flinks_iframe,
    //         employer + job_title, employed_months, pay_frequency, pay_date1
    // =========================================================================
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount__",
        fields: [
            {
                name: 'requested_amount',
                placeholder: '1000',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_1000_less__", "value": "750"},
                    {"text": "__opt_amount_1001_2000__", "value": "1500"},
                    {"text": "__opt_amount_2001_5000__", "value": "3500"},
                    {"text": "__opt_5001_10000__", "value": "7500"},
                    {"text": "__opt_10001_15000__", "value": "15000"},
                    {"text": "__opt_15001_20000__", "value": "20000"},
                    {"text": "__opt_20000_more__", "value": "25000"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideIfCondition: (app) => {
            return app.projectBrandKey && app.projectBrandKey == 'pq';
        },
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__product_purpose__",
        fields: [
            {
                name: 'product_purpose',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_debt_consolidation__", "value": "Debt Consolidation"},
					{"text": "__opt_cc_consolidation__", "value": "Credit Card Consolidation"},
                    {"text": "__opt_emergency_expense__", "value": "Emergency Expense"},
                    {"text": "__opt_car_repair__", "value": "Car Maintenance"},
                    {"text": "__opt_other__", "value": "Other"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // unsecured amount if purpose debt/credit card consolidation
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__cc_debt_amount__',
        fields: [
            {
                name: 'cc_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_2500_less__", "value":"2500" },
                    { "text":"__opt_debt_amounts_2501_5000__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                    { "text":"__opt_debt_no_cc_debt__", "value":"0" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__unsecured_debt_amount__',
        textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    const defaultChoices = [
                        { "text": "__opt_debt_amounts_2500_less__", "value": "2500" },
                        { "text": "__opt_debt_amounts_2501_5000__", "value": "5000" },
                        { "text": "__opt_debt_amounts_5001_10000__", "value": "7500" },
                        { "text": "__opt_debt_amounts_10001_15000__", "value": "10000" },
                        { "text": "__opt_debt_amounts_15001_20000__", "value": "15000" },
                        { "text": "__opt_debt_amounts_20001_25000__", "value": "20000" },
                        { "text": "__opt_debt_amounts_25000_more__", "value": "25000" },
                    ];

                    return app.cc_debt_amount && app.cc_debt_amount > 0
                        ? [...defaultChoices, { "text": "__opt_debt_no_unsecured_debt__", "value": "0" }]
                        : defaultChoices;
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_credit_situation__",
        fields: [
            {
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !!app._isPrepop;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type__",
        fields: [
            {
                name: 'income_type',
                placeholder: '__income_type__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_full__", "value":"full_time" },
                    { "text":"__opt_income_type_part__", "value":"part_time" },
                    { "text":"__opt_income_type_self__", "value":"self_employed" },
                    { "text":"__opt_income_type_benefits__", "value":"social_security" },
                    { "text":"__opt_income_type_disability__", "value":"disability" },
                    { "text":"__opt_income_type_pension__", "value":"retired" },
                    { "text":"__opt_income_type_unemployed__", "value":"unemployed" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__direct_deposit__",
        fields: [
            {
                name: 'direct_deposit',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income__",
        fields: [
            {
                name: 'monthly_income',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_1500_less__", "value":"1500" },
                    { "text":"__opt_1501_2000__", "value":"2000" },
                    { "text":"__opt_2001_3000__", "value":"3000" },
                    { "text":"__opt_3001_4000__", "value":"4000" },
                    { "text":"__opt_4001_5000__", "value":"5000" },
                    { "text":"__opt_5000_more__", "value":"5500" },
                ],
                attrs: {
                    maxlength: 5
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address__",
        // notice (inline version):
        notice: (app) => {
            if (!app._isPrepop) return false;
            if (app.prepop_address) return '__prepop_confirm_address__';
            const country = (app.projectBrandCountry || 'ca').toLowerCase();
            const stored = storageGetJson(`comparehub-user-address-${country}`);
            if (stored?.addressData && new Date(stored.expiry) > new Date()) return '__prepop_confirm_address__';
            return false;
        },
        // notice (modal version):
        // notice: {
        //     content: (app) => {
        //         if (!app._isPrepop) return false;
        //         if (app.prepop_address) return '__prepop_confirm_address__';
        //         const country = (app.projectBrandCountry || 'ca').toLowerCase();
        //         const stored = storageGetJson(`comparehub-user-address-${country}`);
        //         if (stored?.addressData && new Date(stored.expiry) > new Date()) return '__prepop_confirm_address__';
        //         return false;
        //     },
        //     display: 'modal',
        // },
        fields: [
            {
                name: 'address',
                placeholder: '',
                type: 'fulladdress',
                fieldOuterClass: 'col-md-8 offset-md-2',
                value: null,
            },
        ],
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address_length_months__",
        fields: [
            {
                name: 'address_length_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || !options.includes(app.address.province);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                name: 'own_home',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || !options.includes(app.address.province);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount__",
        fields: [
            {
                name: 'requested_amount',
                placeholder: '1000',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    if(app.own_home && app.own_home == 'yes') {
                        return [
                            {"text": "__opt_1000_less__", "value": "750"},
                            {"text": "__opt_amount_1001_2000__", "value": "1500"},
                            {"text": "__opt_amount_2001_5000__", "value": "3500"},
                            {"text": "__opt_5001_10000__", "value": "7500"},
                            {"text": "__opt_10001_15000__", "value": "15000"},
                            {"text": "__opt_15001_20000__", "value": "20000"},
                            {"text": "__opt_20000_more__", "value": "25000"},
                        ];
                    }

                    const choices = [
                        {"text": "__opt_1000_less__", "value": "750"},
                        {"text": "__opt_amount_1001_2000__", "value": "1500"},
                        {"text": "__opt_amount_2001_5000__", "value": "3500"},
                    ];

                    // Non-homeowners with good/fair credit can ask for up to $10K
                    if(['good', 'fair'].includes(app.in_credit_situation)) {
                        choices.push({"text": "__opt_5001_10000__", "value": "7500"});
                    }

                    return choices;
                },
                hideIfHasValue: true,
            },
        ],
        hideIfCondition: (app) => {
            return !app.projectBrandKey || app.projectBrandKey != 'pq';
        },
        hideButtonsSection: true,
    },
    rentMortgagePaymentStep({
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || !options.includes(app.address.province);
        },
    }),
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__living_situation__",
        fields: [
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|propertyMortgage|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app) || fieldConditionHelper.noMortgage(app);
                },
            },
        ],
        // Owners only (renters answered everything on the rent step), same province gate as the rent step.
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return fieldConditionHelper.homeOwner(app) || !app.address || !app.address.province || !options.includes(app.address.province);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeEmailRegistrationCheck',
        title: "__how_to_contact__",
        // notice (inline version):
        notice: (app) => {
            if (!app._isPrepop) return false;
            const name = app.first_name ? ` ${app.first_name.replace(/\b\w/g, c => c.toUpperCase())}` : '';
            return `Hey${name}! __prepop_contact_greeting__`;
        },
        // notice (modal version):
        // notice: {
        //     content: (app) => {
        //         if (!app._isPrepop) return false;
        //         const name = app.first_name ? ` ${app.first_name.replace(/\b\w/g, c => c.toUpperCase())}` : '';
        //         return `Hey${name}! __prepop_contact_greeting__`;
        //     },
        //     display: 'modal',
        // },
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
        ],
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
    {
        beforeCreate: 'enablePartialRequestPerStep',
        beforeNextStep: function() {},
        title: "__sms_verification__",
        notice: (app) => app._isPrepop ? '__prepop_verify_phone__' : false,
        fields: [
            {
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
                hideSubtitles: true,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !app.forceSmsVerification;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                name: 'dob',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_credit_situation__",
        fields: [
            {
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !app._isPrepop;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__flinks_personal_loan__",
        fields: [
            {
                name: 'flinks_iframe',
                type: 'flinks',
                value: null,
            },
        ],
        textBottom: '__flinks_skip__',
        isStepSkippable: false,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary'
    },
    // employment section
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks === 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 4,
                    message: '<h3 class="my-4 text-center h4 text-muted">Searching for providers in your area...</h3>'
                },
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Evaluating your options...</h3>'
                },
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Great news! Loan options are available in your area</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__employer_information__",
        fields: [
            {
                label: '__employer_name__',
                name: 'employer',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            {
                label: '__job_title__',
                name: 'job_title',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
        ],
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app) || (app.income_type && app.income_type == 'self_employed');
        }
    },
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks === 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Processing...</h3>'
                },
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Evaluating your options, this might take a moment...</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__employed_months__",
        fields: [
            {
                name: 'employed_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_employed_months_3_less__", "value":"2" },
                    { "text":"__opt_employed_months_3_6__", "value":"6" },
                    { "text":"__opt_employed_months_6_12__", "value":"12" },
                    { "text":"__opt_employed_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks === 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Processing...</h3>'
                },
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Almost finished...</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__pay_frequency__",
        fields: [
            {
                name: 'pay_frequency',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_weekly__", "value":"WEEKLY" },
                    { "text":"__opt_bi_weekly__", "value":"BIWEEKLY" },
                    { "text":"__opt_semi_monthly__", "value":"TWICEMONTHLY" },
                    { "text":"__opt_monthly__", "value":"MONTHLY" },
                ],
                hideIfHasValue: true,
            }
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks === 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Comparing results...</h3>'
                },
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Congrats! Financing offers found!</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__pay_date1__",
        fields: [
            {
                name: 'pay_date1',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|date|paydate',
                fieldOuterClass: 'col-md-6 offset-md-3',
                clearfixTop: true,
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    // =========================================================================
    // Member Enrollment (registration + verification sub-flow)
    // Internally uses: form/steps/registration.js (wants to create account? yes/no)
    //                  form/steps/registered.js (SMS verification + email/password → executeCreateAccount)
    //                  form/steps/verification.js (wants Equifax verification? yes/no)
    //                  components/MemberVerification.vue (EID quiz flow via form/steps/verification-eid.js)
    // =========================================================================
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "",
        hideIfCondition: (app) => {
            // MEMBER_ACCOUNT_CREATION_ENABLED=false skips the whole step (e.g. while Equifax is down).
            return fieldConditionHelper.memberAccountCreationDisabled() || app.is_user_registered === true;
        },
        fields: [
            {
                name: 'member_enrollment',
                type: 'memberenrollment',
                value: null,
            },
        ],
        hideButtonsSection: true,
    },
    // =========================================================================
    // Post-flow steps originally from: form/steps/unregistered.js
    // (identical in verified.js and unverified.js)
    // Fields: address_length_months (non-ON/BC/QC), own_home (non-ON/BC/QC),
    //         living_situation (non-ON/BC/QC), citizen_status,
    //         cc_debt_amount (if not already set), unsecured_debt_amount (if not already set)
    // =========================================================================
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address_length_months_current__",
        fields: [
            {
                name: 'address_length_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                name: 'own_home',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    rentMortgagePaymentStep({
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        },
    }),
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__living_situation__",
        fields: [
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|propertyMortgage|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app) || fieldConditionHelper.noMortgage(app);
                },
            },
        ],
        // Owners only (renters answered everything on the rent step), same province gate as the rent step.
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return fieldConditionHelper.homeOwner(app) || !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks === 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Finalizing results...</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                name: 'canadian_status',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__", "value":"pr" },
                    { "text":"__opt_cs_work__", "value":"work_permit" },
                    { "text":"__opt_cs_student__", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__cc_debt_amount__",
        fields: [
            {
                name: 'cc_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_2500_less__", "value":"2500" },
                    { "text":"__opt_debt_amounts_2501_5000__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                    { "text":"__opt_debt_no_cc_debt__", "value":"0" },
                ]
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !!app.cc_debt_amount;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__unsecured_debt_amount__",
        textTop: "__unsecured_debt_amount_definition__",
        fields: [
            {
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    const defaultChoices = [
                        { "text": "__opt_debt_amounts_2500_less__", "value": "2500" },
                        { "text": "__opt_debt_amounts_2501_5000__", "value": "5000" },
                        { "text": "__opt_debt_amounts_5001_10000__", "value": "7500" },
                        { "text": "__opt_debt_amounts_10001_15000__", "value": "10000" },
                        { "text": "__opt_debt_amounts_15001_20000__", "value": "15000" },
                        { "text": "__opt_debt_amounts_20001_25000__", "value": "20000" },
                        { "text": "__opt_debt_amounts_25000_more__", "value": "25000" },
                        { "text": "__opt_debt_no_unsecured_debt__", "value": "0" },
                    ];

                    return defaultChoices;
                },
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !!app.unsecured_debt_amount;
        }
    },
    // =========================================================================
    // Credit authorization (final step, originally the last step before submission)
    // =========================================================================
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        fields: [
            {
                name: 'credit_auth',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-12',
                choices: [
                    { "text":"__opt_credit_auth_2__", "value":"2", "btnClass":"btn-success" },
                    { "text":"__opt_credit_auth_1__", "value":"1", "btnClass":"btn-outline-secondary" },
                ]
            },
        ],
        textTop: '__hard_credit_check__',
        hideIfCondition: (app) => {
            return fieldConditionHelper.meetsSkcpConditions(app);
        },
        hideButtonsSection: true,
    },
];

export default steps;
